


















import {
  Component,
  Vue,
} from 'vue-property-decorator';

import { ProductInventory } from '@/models/productInventory';

@Component({
  filters: {
    formatRestockDate: (d: Date) => (
      d.toLocaleString('zh-TW', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      })
    ),
  },
  props: {
    inventory: {
      type: ProductInventory,
      required: true,
    },
  },
})
export default class AvailabilityBlock extends Vue { }

